import { useQuery, useMutation } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_API_URL;

export const changePatientAdminCounter = async (numero_de_dni, pass) => {
  const response = await fetch(`${apiUrl}/api/cambiar_contra_admin_paciente`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      numero_de_dni,
      pass,
    }),
  });

  if (!response.ok) {
    throw new Error('Error updating patient password');
  }

  return response.json();
};

export const loginExternal = async (email, password, rememberMe) => {
  const response = await fetch(`${apiUrl}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      email,
      password,
      remember_me: rememberMe,
    }),
  });

  if (!response.ok) {
    throw new Error('Unauthorized');
  }

  return response.json();
};

export const changePassword = async data => {
  const response = await fetch(`${apiUrl}/api/cambiar_contrase`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Error al cambiar contraseña');
  }

  return response.json();
};

export const changePassword2 = async data => {
  const response = await fetch(`${apiUrl}/api/cambiar_contrase2`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Error al cambiar contraseña');
  }

  return response.json();
};

export const signUp = async data => {
  const response = await fetch(`${apiUrl}/api/auth/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Error al registrar usuario');
  }

  // 👇 CLAVE: si no hay contenido, no intentes parsear
  if (response.status === 204) {
    return null;
  }

  const text = await response.text();

  // por seguridad extra
  return text ? JSON.parse(text) : null;
};

export const addMultiplePatients = async (userEmail, patients) => {
  const response = await fetch(`${apiUrl}/api/auth/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_email: userEmail,
      patients,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData?.data || 'Error creando pacientes');
  }

  return response.json();
};
